export const isImageUrl = (url: string): boolean => {
  // Match image extensions at the end of the path, possibly followed by query or fragment
  return /\.(jpg|jpeg|png|gif|webp|svg|bmp|tiff|avif)(\?.*)?(#.*)?$/i.test(url)
}

// Pairing code shared contract between web-player (generator/display) and cms-app (validator/consumer).
// Both ends must agree on length, charset and the query-param name used in the QR deep-link.
export const PAIRCODE_LENGTH = 6
export const PAIRCODE_REGEX = /^[a-z]{6}$/
export const PAIRCODE_QUERY_PARAM = 'paircode'
export const SIGNAGESPACE_DASHBOARD_BASE = 'https://app.signagespace.com'

export function isValidPaircode(value: string | null | undefined): value is string {
  return typeof value === 'string' && PAIRCODE_REGEX.test(value)
}

export function buildPairingDeepLink(paircode: string): string {
  return `${SIGNAGESPACE_DASHBOARD_BASE}/cms/#/screen/new?${PAIRCODE_QUERY_PARAM}=${encodeURIComponent(paircode)}`
}

// Seed content every new account gets (see backend src/content/default-data.ts): media/apps
// named `signage-space-*` and a `Default Playlist`. Accounts created before channels closed
// also have a `Default Channel`. Used on both ends, so it lives here.
export const DEFAULT_CONTENT_NAME_PREFIX = 'signage-space-'
export const DEFAULT_PLAYLIST_NAME = 'Default Playlist'
export const DEFAULT_CHANNEL_NAME = 'Default Channel'
